// extracted by mini-css-extract-plugin
export default {"modal":"CompanyModal_modal__LnRI-"};